import { PRODUCT_DOMAIN } from "@/constants";

const productDomainMap: Record<string, boolean> = {
  IRE: false,
  EXP: true,
  STS: false,
  AVN: false,
  ESP: false,
};

export const getProductDomain = (): boolean => {
  return productDomainMap[PRODUCT_DOMAIN] ?? "STS";
};
